import Checkbox from "components/Cards/Card/Actions/Checkbox"

import { ComponentProps } from "."

const IsAddHomeVideo = ({ checked, isDisabled, onChange }: ComponentProps) => (
  <Checkbox
    checked={checked}
    disabled={isDisabled}
    inputId="isAddHomeVideo"
    label="Add Home Video"
    name="isAddHomeVideo"
    onChange={onChange}
  />
)

export default IsAddHomeVideo
